module.exports = __webpack_public_path__ + "static/img/1_5.bb0e41a2.jpg";